import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=00f5272e&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00f5272e')) {
      api.createRecord('00f5272e', component.options)
    } else {
      api.reload('00f5272e', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=00f5272e&", function () {
      api.rerender('00f5272e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HKG2OPqc1T14/JS/comp/ImgFallback.vue"
export default component.exports